// The deliveries service names a failed attempt by its reason; a null reason is a success.
export const ATTEMPT_REASON_LABELS: Record<string, string> = {
    redirection_error: 'Redirection Error',
    too_many_requests_error: 'Too Many Requests Error',
    client_error: 'Client Error',
    server_error: 'Server Error',
    network_error: 'Network Error',
    timeout_error: 'Timeout Error',
    auth_config_error: 'Auth Config Error',
    internal_error: 'Internal Error',
};

// Only an attempt that reached the destination has a response to show.
export const ATTEMPT_REASONS_WITH_RESPONSE: (string | null)[] = [
    null,
    'redirection_error',
    'client_error',
    'server_error',
];

export const attemptReasonLabel = (reasonCode: string | null): string =>
    null === reasonCode ? 'Success' : ATTEMPT_REASON_LABELS[reasonCode] ?? 'Unknown';

export const attemptHasResponse = (reasonCode: string | null): boolean =>
    ATTEMPT_REASONS_WITH_RESPONSE.includes(reasonCode);
